import Vue from 'vue'
import store from '@/store'
import NProgress from 'nprogress'
const hideTimeoutDuration = 30 * 1000 //By default, the loader will hide itself after 30s
var hideTimeout = null

NProgress.configure({ showSpinner: true })

const plugin = {
  cmp: null,
  register(cmp) {
    this.cmp = cmp
  },
  async showUntilPromiseResolves(promise = null) {
    return this.show(promise)
  },
  isVisible() {
    return this.cmp && this.cmp.visible
  },
  /**
   * This is the loader we use for route change (a tiny animated bar in the top of the page)
   *
   * Also: Vuex - Search module: Validate button will show a loader
   *
   * @param Promise Hide when promise is resolved (Optional)
   * @return [Promise/Function]
   */
  showAlternative(promise = null) {
    console.debugVerboseScope(8, 'loader', 'loader.showAlternative')
    NProgress.done()
    NProgress.start()
    //NProgress.set(0.1)
    store.state.search_module.isSearchInProgress = true
    if (promise && !(promise instanceof Promise)) {
      throw new Error('Expects promise as first argument')
    }
    if (promise && promise instanceof Promise) {
      return new Promise((resolve, reject) => {
        promise
          .then(resolve)
          .catch(reject)
          .finally(() => {
            console.debugVerboseScope(
              8,
              'loader',
              'loader.showAlternative.done (finally)'
            )
            NProgress.done(true)
            store.state.search_module.isSearchInProgress = false
          })
      })
    } else {
      return () => {
        console.debugVerboseScope(
          8,
          'loader',

          'loader.showAlternative.done (callback)'
        )
        NProgress.done(true)
        store.state.search_module.isSearchInProgress = false
      }
    }
  },
  hideAlternative() {
    console.debugVerboseScope(8, 'loader', 'loader.showAlternative.done (fn)')
    NProgress.done(true)
    store.state.search_module.isSearchInProgress = false
  },
  /**
   * Show loader during heavy, CPU intense synchronous function
   * @param {Function} callback
   */
  showWhile(callback) {
    if (typeof callback !== 'function') {
      throw new Error('callback function expected')
    }
    this.show()
    setTimeout(() => {
      callback && callback()
      this.hide()
    }, 100) //Give some time to render before getting stuck with callback
  },
  /**
   *
   * @param {Promise} promise Optional promise. If provided, loader will hide when promises resolves.
   * @returns
   */
  async show(promise = null) {
    return new Promise((resolve, reject) => {
      this.cmp.toggleVisible(true).then(resolve).catch(reject) //Will resolve on loader $nextTick
      if (promise instanceof Promise) {
        promise.finally(() => this.hide())
      } else {
        if (hideTimeout) {
          clearTimeout(hideTimeout)
          hideTimeout = null
        }
        hideTimeout = setTimeout(() => {
          this.hide()
        }, hideTimeoutDuration)
      }
    })
  },
  /**
   * Hide current loader
   */
  hide() {
    this.cmp && this.cmp.toggleVisible(false)
    if (hideTimeout) {
      clearTimeout(hideTimeout)
    }
  },
}

export default plugin

Vue.use({
  install() {
    Vue.prototype.$loader = Vue.$loader = plugin
  },
})
